<script>
	export let node;
	export let type;
	export let highlighted;
	export let color;
	export let formatValue;
	export let formatGDP;

	$: showValue = node.value > 200e9;
</script>

<div class="label {type || ''}" class:bold={showValue || highlighted} style:color>
	{node.label}
</div>
{#if showValue}
	<div class="value {type || ''}" class:bold={highlighted}>{formatValue(node.value)}</div>
	{#if highlighted}
		<div class="value gdp {type || ''}">{formatGDP(node.gdpPercentage)}</div>
	{/if}
{/if}

<style lang="scss">
	.bold {
		font-weight: $bold;
	}

	.source {
		text-align: right;
		right: 0;
	}

	.target {
		text-align: left;
		left: 0;
	}

	.label {
		filter: brightness(0.8);
	}

	.value {
		white-space: nowrap;
		opacity: 0.7;
	}

	.gdp {
		position: absolute;
		font-weight: $medium;
		opacity: 0.5;
		// padding-top: 4px;
	}
</style>
